import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i326945391__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Krankenhaus", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i326945391__cls-1{fill:none}.i326945391__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M40 41.99V174c0 1.1.91 2 2.03 2H92v-19.68h8V176h49.97c1.12 0 2.03-.9 2.03-2V41.99c0-1.1-.91-2-2.03-2H124V60c0 2.21-1.79 4-4 4H72c-2.21 0-4-1.79-4-4V39.99H42.03c-1.12 0-2.03.9-2.03 2m80 37.98h24v8h-24zm0 24.03h24v8h-24zm0 24h24v8h-24zM84 79.97h24v8H84zM84 104h24v8H84zm0 24h24v8H84zM48 79.97h24v8H48zM48 104h24v8H48zm0 24h24v8H48z",
      class: "i326945391__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M76 56h40V16H76zm8-24h8v-8.02h8V32h7.73v8H100v7.99h-8V40h-8z",
      class: "i326945391__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M120 8H72c-2.21 0-4 1.79-4 4v19.99H42.03c-5.53 0-10.03 4.49-10.03 10V174c0 5.52 4.5 10 10.03 10h107.94c5.53 0 10.03-4.49 10.03-10V41.99c0-5.51-4.5-10-10.03-10H124V12c0-2.21-1.79-4-4-4m-44 8h40v40H76zm73.97 23.99c1.12 0 2.03.9 2.03 2V174c0 1.1-.91 2-2.03 2H100v-19.68h-8V176H42.03c-1.12 0-2.03-.9-2.03-2V41.99c0-1.1.91-2 2.03-2H68V60c0 2.21 1.79 4 4 4h48c2.21 0 4-1.79 4-4V39.99z",
      class: "i326945391__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M100 23.98h-8V32h-8v8h8v7.99h8V40h7.73v-8H100zM48 79.97h24v8H48zM84 79.97h24v8H84zM120 79.97h24v8h-24zM48 104h24v8H48zM84 104h24v8H84zM120 104h24v8h-24zM48 128h24v8H48zM84 128h24v8H84zM120 128h24v8h-24z",
      class: "i326945391__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "hospital"}) } }